export default "__VITE_ASSET__09d41188__"